import React, { createContext, useContext, useState } from "react"

const PricingContext = createContext();
export const usePricing = () => useContext(PricingContext);

/**
 * This function creates a provider to retrieve pricing data for an offer from the backend
 * Components can access this providers data through the exposed usePricing Context.
 * @param {*} children Children of Provider
 * @returns {PricingContext.PricingProvider}
 */
export default function PricingProvider({ children }) {
  const [pricing, setPricing] = useState([]);
  const [errorMessage, setErrorMessage] = useState();
  const [isLoading, setLoading] = useState(true);
  const [warning, setWarning] = useState(null);

  const getPricing = async (payload, getPricingDTO) => {
    setLoading(true);
    setPricing([]);
    setWarning(null);
    try {
      const pricingResp = await getPricingDTO(payload);
      if (pricingResp?.pricing) {
        setPricing(pricingResp.pricing);
        setErrorMessage(null);
        // Store warning if present in response
        if (pricingResp?.warning) {
          setWarning(pricingResp.warning);
        }
      }
    } catch (error) {
      setErrorMessage(error.message);
    }
    setLoading(false);
  }

  return (
    <PricingContext.Provider value={{ pricing, errorMessage, isLoading, getPricing, warning }}>
      {children}
    </PricingContext.Provider>
  );
};